<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<el-table row-key="id" size="mini"  v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
							 element-loading-background="rgba(0, 0, 0, 0.8)"  ref="multipleTable" :data="tableData" style="width: 100%" border :header-cell-style="{background:'#E5E7EE',color:'#000000'}">
						<el-table-column type="selection" width="55" align="center">
						</el-table-column>
						<el-table-column align="center" :prop="dropCol[index].prop" :label="item.label"
							v-for="(item,index) in col" :key="`col_${index}`" :width="index == 0 ?'55':''">
						</el-table-column>
<!-- 						<el-table-column prop="title" label="标题" align="center">
						</el-table-column> -->
					<el-table-column prop="must" label="必填" align="center"  :formatter="getStatus">
						<template slot-scope="scope">
							<el-switch @change="updateTop(scope.$index,scope.row)" v-model="scope.row.must"  active-color="#13ce66"
							 inactive-color="#dcdfe6" :active-value="1"  :inactive-value="0" >
							</el-switch>
						</template>
					</el-table-column>
						<el-table-column fixed="right" label="更多操作">
							<template slot-scope="scope">
							<!-- 	<el-button @click.native.prevent="update('update',scope.$index, scope.row)" type="text" size="small">
									编辑
								</el-button>
								<span>|</span>
								<el-button @click.native.prevent="deleteRow(scope.$index, scope.row)" type="text" size="small">
									删除
								</el-button> -->
								<el-button type="success" icon="el-icon-edit" circle  size="small"  @click.native.prevent="update('update',scope.row)"></el-button>
									<el-button type="danger" icon="el-icon-delete" circle  @click.native.prevent="deleteRow(scope.$index,scope.row)"  size="small"></el-button>
								
							</template>
						</el-table-column>
					</el-table>
					<div class="tableFooter">
						<button class="selectAll"  @click="toggleSelection(tableData)">全选</button>
						<input type="button" class="add" @click="update('add')" value="添加参数">
						<input  type="button" class="del" @click="selectDel" value="批量删除">
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
					 :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
	export default {
		data() {
			return {
				tableData: [
				],
				currentPage: 1,
				pageSize: 5,
				total: 0,
				multipleTable: [],
				loading:false,
				col: [{
						label: '编号',
						prop: 'id'
					},
					{
						label: '标题',
						prop:'title'
					},
					
				],
				dropCol: [{
						label: '编号',
						prop: 'id'
					},
					{
						label: '标题',
						prop:'title'
					},
					
				],
			}
		},
		created() {
			this.getData(this.currentPage, this.pageSize)
		},
	mounted() {
		this.rowDrop()
	},
	methods: {
		// 行拖拽
		rowDrop() {
			const tbody = document.querySelector('.el-table__body-wrapper tbody')
			const _this = this
			this.Sortable.create(tbody, {
				onEnd({
					newIndex,
					oldIndex
				}) {
					const currRow = _this.tableData.splice(oldIndex, 1)[0]
					_this.tableData.splice(newIndex, 0, currRow)
				}
			})
		},
			getStatus(row,column){
				return row.must == 1?true :false
			},
			//获取列表数据
			getData(currentPage, pageSize){
				this.loading = true
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v1/message/param/page',
					params: {
 
						title:'',
						must:'',
						pageNum: currentPage,
						pageSize: pageSize
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.loading = false
						this.tableData = res.data.data.data
						this.total = res.data.data.total
					} else {
						obj.$message.error(res.message)
					}
				})
			},
			update(iden, index, rows) {
				this.$router.push({
					path: '/home/pUpdate',
					query:{
						iden:iden,
						rows:rows
					}
				})
			},
			deleteRow(index, rows) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.loading = true
					var obj = this;
					obj.$http({
						method: 'get',
						url: 'api/v1/message/param/delete',
						params: {
							id: rows.id,
							uid: localStorage.getItem('uid')
						},
					}).then((res) => {
						if (res.data.status == 200) {
							this.loading = false
							obj.$message.success('删除成功')
							this.getData(this.currentPage, this.pageSize)
						} else {
							obj.$message.error(res.data.message)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
				
			},
			//分页事件
			handleSizeChange(val) {
				this.pageSize = val; //将每页显示的条数 = 改变的值
				this.getData(this.currentPage, this.pageSize)
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData(this.currentPage, this.pageSize)
			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			//批量删除
			selectDel() {
			
				if (this.$refs.multipleTable.selection.length == 0) {
					this.$message.error('请选择要删除的表格信息！');
					return;
				}
				var list = []
				for (var i = 0; i < this.$refs.multipleTable.selection.length; i++) {
					list.push(this.$refs.multipleTable.selection[i].id)
				}
				this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.loading = true
					var obj = this;
					obj.$http({
						method: 'get',
						url: 'api/v1/message/param/clear',
						params: {
							ids: list.toString(),
							uid: localStorage.getItem('uid')
						},
					}).then((res) => {
						if (res.data.status == 200) {
							this.loading = false
							obj.$message.success('删除成功')
							this.getData(this.currentPage, this.pageSize)
						} else {
							obj.$message.error(res.data.message)
						}
					})
			
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			updateTop(index,rows){
				this.loading = true
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/message/param/change/must',
					params: {
						id: rows.id,
 
						must: rows.must
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.loading = false
						obj.$message.success('修改成功')
						this.getData(this.currentPage, this.pageSize)
					} else {
						obj.$message.error(res.data.message)
					}
				})
			}
		}
	}
</script>

<style scoped="scoped">
	/deep/ .el-button--text {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}

	span {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/views/content/message/Mparameter.vue